export const appRouteFamilyPatterns = [
  "/",
  "/[organization-slug]",
  "/[organization-slug]/agencies",
  "/[organization-slug]/agencies/[agency-id]",
  "/[organization-slug]/agencies/[agency-id]/allocations",
  "/[organization-slug]/agencies/[agency-id]/insurance",
  "/[organization-slug]/agencies/[agency-id]/notes",
  "/[organization-slug]/agencies/[agency-id]/students",
  "/[organization-slug]/agencies/[agency-id]/sub-agencies",
  "/[organization-slug]/agencies/[agency-id]/team-members",
  "/[organization-slug]/agencies/allocations",
  "/[organization-slug]/agencies/new",
  "/[organization-slug]/applications",
  "/[organization-slug]/applications/[application-id]",
  "/[organization-slug]/applications/students",
  "/[organization-slug]/applications/students/[view]",
  "/[organization-slug]/atlas",
  "/[organization-slug]/background-checks",
  "/[organization-slug]/background-checks/all",
  "/[organization-slug]/background-checks/authorizations",
  "/[organization-slug]/background-checks/completed",
  "/[organization-slug]/background-checks/host-families",
  "/[organization-slug]/background-checks/in-progress",
  "/[organization-slug]/background-checks/needs-action",
  "/[organization-slug]/background-checks/needs-review",
  "/[organization-slug]/cases",
  "/[organization-slug]/cases/[case-id]",
  "/[organization-slug]/cases/tags",
  "/[organization-slug]/chat",
  "/[organization-slug]/districts",
  "/[organization-slug]/documents",
  "/[organization-slug]/documents/[document-id]",
  "/[organization-slug]/documents/templates",
  "/[organization-slug]/documents/templates/[template-id]",
  "/[organization-slug]/events",
  "/[organization-slug]/finance",
  "/[organization-slug]/finance/expenses",
  "/[organization-slug]/finance/expenses/[finance-section]",
  "/[organization-slug]/finance/expenses/[finance-section]/[price-id]",
  "/[organization-slug]/finance/expenses/credits/new",
  "/[organization-slug]/finance/expenses/expenses/new",
  "/[organization-slug]/finance/expenses/payments/new",
  "/[organization-slug]/finance/expenses/repayments/new",
  "/[organization-slug]/finance/invoices",
  "/[organization-slug]/finance/invoices/[finance-section]",
  "/[organization-slug]/finance/invoices/[finance-section]/[price-id]",
  "/[organization-slug]/finance/invoices/credits/new",
  "/[organization-slug]/finance/invoices/new",
  "/[organization-slug]/finance/invoices/payments/new",
  "/[organization-slug]/finance/invoices/refunds/new",
  "/[organization-slug]/home",
  "/[organization-slug]/home/admissions",
  "/[organization-slug]/home/agency-operations",
  "/[organization-slug]/home/agency-recruitment",
  "/[organization-slug]/home/compliance",
  "/[organization-slug]/home/host-families",
  "/[organization-slug]/home/placements",
  "/[organization-slug]/home/project-help",
  "/[organization-slug]/home/student-services",
  "/[organization-slug]/home/supervisions",
  "/[organization-slug]/home/team-members",
  "/[organization-slug]/host-families",
  "/[organization-slug]/host-families/[host-family-profile-id]",
  "/[organization-slug]/host-families/[host-family-profile-id]/background-checks",
  "/[organization-slug]/host-families/[host-family-profile-id]/documents",
  "/[organization-slug]/host-families/[host-family-profile-id]/folder",
  "/[organization-slug]/host-families/[host-family-profile-id]/members",
  "/[organization-slug]/host-families/[host-family-profile-id]/notes",
  "/[organization-slug]/host-families/[host-family-profile-id]/references",
  "/[organization-slug]/host-families/[host-family-profile-id]/schools",
  "/[organization-slug]/host-families/[host-family-profile-id]/screening",
  "/[organization-slug]/host-families/[host-family-profile-id]/students",
  "/[organization-slug]/host-families/active",
  "/[organization-slug]/host-families/applicants",
  "/[organization-slug]/host-families/leads",
  "/[organization-slug]/host-families/new",
  "/[organization-slug]/host-families/references",
  "/[organization-slug]/inbox",
  "/[organization-slug]/insurance",
  "/[organization-slug]/insurance/agency-choice",
  "/[organization-slug]/insurance/assignments",
  "/[organization-slug]/insurance/batches",
  "/[organization-slug]/insurance/batches/[batch-id]",
  "/[organization-slug]/insurance/batches/new",
  "/[organization-slug]/insurance/enrollments",
  "/[organization-slug]/insurance/exceptions",
  "/[organization-slug]/insurance/participants",
  "/[organization-slug]/insurance/plans",
  "/[organization-slug]/insurance/plans/[plan-id]",
  "/[organization-slug]/insurance/settings",
  "/[organization-slug]/leads",
  "/[organization-slug]/leads/[lead-id]",
  "/[organization-slug]/marketing/flyers",
  "/[organization-slug]/marketing/graphics",
  "/[organization-slug]/marketing/social-graphics-gallery",
  "/[organization-slug]/my-applications",
  "/[organization-slug]/my-compliance",
  "/[organization-slug]/my-folder",
  "/[organization-slug]/organization-memberships/[organization-membership-id]",
  "/[organization-slug]/organization/background-checks",
  "/[organization-slug]/organization/employee-configuration",
  "/[organization-slug]/organization/forms",
  "/[organization-slug]/organization/forms/[form-id]",
  "/[organization-slug]/organization/forms/[form-id]/reviews",
  "/[organization-slug]/organization/goals",
  "/[organization-slug]/organization/goals/[season-id]",
  "/[organization-slug]/organization/incentives",
  "/[organization-slug]/organization/incentives/[incentive-id]",
  "/[organization-slug]/organization/placement-groups",
  "/[organization-slug]/organization/program-templates",
  "/[organization-slug]/organization/program-templates/[program-template-id]",
  "/[organization-slug]/organization/programs",
  "/[organization-slug]/organization/programs/[program-id]",
  "/[organization-slug]/organization/programs/types",
  "/[organization-slug]/organization/programs/types/[organization-program-type-id]",
  "/[organization-slug]/organization/quizzes",
  "/[organization-slug]/organization/quizzes/[quiz-id]",
  "/[organization-slug]/organization/quizzes/results",
  "/[organization-slug]/organization/regions-states",
  "/[organization-slug]/organization/roles",
  "/[organization-slug]/organization/settings",
  "/[organization-slug]/organization/statuses",
  "/[organization-slug]/organization/visibilities",
  "/[organization-slug]/organization/waitlists",
  "/[organization-slug]/organization/widgets",
  "/[organization-slug]/profile",
  "/[organization-slug]/progress-reports",
  "/[organization-slug]/project-help",
  "/[organization-slug]/project-help/[projectId]",
  "/[organization-slug]/project-help/categories",
  "/[organization-slug]/project-help/participants",
  "/[organization-slug]/project-help/tshirt-orders",
  "/[organization-slug]/quiz-instance/[quiz-instance-id]",
  "/[organization-slug]/quizzes",
  "/[organization-slug]/quizzes/[quiz-id]",
  "/[organization-slug]/quizzes/results",
  "/[organization-slug]/reports",
  "/[organization-slug]/reports/hf-monthly-payments",
  "/[organization-slug]/reports/payment-immigration-report",
  "/[organization-slug]/reports/placement-report",
  "/[organization-slug]/reports/placement-report-detailed",
  "/[organization-slug]/reports/placements-by-team-member",
  "/[organization-slug]/reports/placements-by-unique-hfs",
  "/[organization-slug]/reports/relocations-report",
  "/[organization-slug]/reports/student-numbers-allocations",
  "/[organization-slug]/reports/tm-recruitment",
  "/[organization-slug]/requirements",
  "/[organization-slug]/resources",
  "/[organization-slug]/resources/agency",
  "/[organization-slug]/resources/documents",
  "/[organization-slug]/resources/training",
  "/[organization-slug]/resources/training-event-request",
  "/[organization-slug]/schools",
  "/[organization-slug]/schools/[school-id]",
  "/[organization-slug]/schools/[school-id]/admissions-fees",
  "/[organization-slug]/schools/[school-id]/dates",
  "/[organization-slug]/schools/[school-id]/folder",
  "/[organization-slug]/schools/[school-id]/officials",
  "/[organization-slug]/schools/[school-id]/related-schools",
  "/[organization-slug]/schools/[school-id]/students",
  "/[organization-slug]/schools/new",
  "/[organization-slug]/second-visits",
  "/[organization-slug]/sevis/agency-choice",
  "/[organization-slug]/sevis/aros",
  "/[organization-slug]/sevis/batches",
  "/[organization-slug]/sevis/batches/[batch-id]",
  "/[organization-slug]/sevis/deadlines",
  "/[organization-slug]/sevis/ds-verification",
  "/[organization-slug]/sevis/exceptions",
  "/[organization-slug]/sevis/paid-fees-uploads",
  "/[organization-slug]/sevis/participants",
  "/[organization-slug]/sevis/queued-events",
  "/[organization-slug]/sevis/receipts-uploads",
  "/[organization-slug]/sevis/settings",
  "/[organization-slug]/sevis/signature-batches",
  "/[organization-slug]/sevis/signature-batches/[signature-batch-id]",
  "/[organization-slug]/students",
  "/[organization-slug]/students/[student-profile-id]",
  "/[organization-slug]/students/[student-profile-id]/applications",
  "/[organization-slug]/students/[student-profile-id]/cases",
  "/[organization-slug]/students/[student-profile-id]/documents",
  "/[organization-slug]/students/[student-profile-id]/feedback",
  "/[organization-slug]/students/[student-profile-id]/folder",
  "/[organization-slug]/students/[student-profile-id]/insurance",
  "/[organization-slug]/students/[student-profile-id]/notes",
  "/[organization-slug]/students/[student-profile-id]/progress-reports",
  "/[organization-slug]/students/[student-profile-id]/second-visits",
  "/[organization-slug]/students/[student-profile-id]/travel",
  "/[organization-slug]/students/[student-profile-id]/visa",
  "/[organization-slug]/students/new",
  "/[organization-slug]/team-members",
  "/[organization-slug]/team-members/[employee-profile-id]",
  "/[organization-slug]/team-members/[employee-profile-id]/background-checks",
  "/[organization-slug]/team-members/[employee-profile-id]/documents",
  "/[organization-slug]/team-members/[employee-profile-id]/folder",
  "/[organization-slug]/team-members/[employee-profile-id]/host-families",
  "/[organization-slug]/team-members/[employee-profile-id]/references",
  "/[organization-slug]/team-members/[employee-profile-id]/schools",
  "/[organization-slug]/team-members/[employee-profile-id]/screening",
  "/[organization-slug]/team-members/[employee-profile-id]/students",
  "/[organization-slug]/team-members/[employee-profile-id]/trainings",
  "/[organization-slug]/team-members/applicants",
  "/[organization-slug]/team-members/leads",
  "/[organization-slug]/team-members/new",
  "/[organization-slug]/teams",
  "/[organization-slug]/teams/[team-id]",
  "/[organization-slug]/teams/[team-id]/host-families",
  "/[organization-slug]/teams/[team-id]/members",
  "/[organization-slug]/teams/[team-id]/students",
  "/[organization-slug]/teams/[team-id]/sub-teams",
  "/[organization-slug]/travel",
  "/[organization-slug]/visa-interviews",
  "/a/[agency-id]",
  "/a/[agency-id]/agencies",
  "/a/[agency-id]/agencies/[subagency-id]",
  "/a/[agency-id]/agencies/[subagency-id]/notes",
  "/a/[agency-id]/agencies/[subagency-id]/settings",
  "/a/[agency-id]/agencies/[subagency-id]/students",
  "/a/[agency-id]/agencies/[subagency-id]/sub-agencies",
  "/a/[agency-id]/agencies/[subagency-id]/team-members",
  "/a/[agency-id]/agencies/new",
  "/a/[agency-id]/applications",
  "/a/[agency-id]/applications/[application-id]",
  "/a/[agency-id]/applications/students",
  "/a/[agency-id]/applications/students/[view]",
  "/a/[agency-id]/chat",
  "/a/[agency-id]/data-verification",
  "/a/[agency-id]/finance",
  "/a/[agency-id]/finance/invoices/[invoice-id]",
  "/a/[agency-id]/home",
  "/a/[agency-id]/inbox",
  "/a/[agency-id]/insurance",
  "/a/[agency-id]/insurance/batches",
  "/a/[agency-id]/insurance/batches/[batch-id]",
  "/a/[agency-id]/insurance/batches/new",
  "/a/[agency-id]/insurance/enrollments",
  "/a/[agency-id]/insurance/participants",
  "/a/[agency-id]/insurance/plans",
  "/a/[agency-id]/insurance/plans/[plan-id]",
  "/a/[agency-id]/members",
  "/a/[agency-id]/members/[agency-membership-id]",
  "/a/[agency-id]/profile",
  "/a/[agency-id]/progress-reports",
  "/a/[agency-id]/resources",
  "/a/[agency-id]/settings",
  "/a/[agency-id]/students",
  "/a/[agency-id]/students/[student-profile-id]",
  "/a/[agency-id]/students/[student-profile-id]/applications",
  "/a/[agency-id]/students/[student-profile-id]/documents",
  "/a/[agency-id]/students/[student-profile-id]/documents/[document-id]",
  "/a/[agency-id]/students/[student-profile-id]/feedback",
  "/a/[agency-id]/students/[student-profile-id]/folder",
  "/a/[agency-id]/students/[student-profile-id]/insurance",
  "/a/[agency-id]/students/[student-profile-id]/notes",
  "/a/[agency-id]/students/[student-profile-id]/progress-reports",
  "/a/[agency-id]/students/[student-profile-id]/travel",
  "/a/[agency-id]/students/[student-profile-id]/visa",
  "/a/[agency-id]/students/new",
  "/a/[agency-id]/travel",
  "/admin",
  "/admin/agencies",
  "/admin/agencies/[agencyId]",
  "/admin/data-transfer/field-mapping",
  "/admin/forms",
  "/admin/forms/[form-id]",
  "/admin/organizations",
  "/agencies",
  "/agencies/[agency-id]",
  "/agencies/[agency-id]/allocations",
  "/agencies/[agency-id]/insurance",
  "/agencies/[agency-id]/notes",
  "/agencies/[agency-id]/students",
  "/agencies/[agency-id]/sub-agencies",
  "/agencies/[agency-id]/team-members",
  "/agencies/[subagency-id]",
  "/agencies/[subagency-id]/notes",
  "/agencies/[subagency-id]/settings",
  "/agencies/[subagency-id]/students",
  "/agencies/[subagency-id]/sub-agencies",
  "/agencies/[subagency-id]/team-members",
  "/agencies/allocations",
  "/agencies/new",
  "/applications",
  "/applications/[application-id]",
  "/applications/students",
  "/applications/students/[view]",
  "/atlas",
  "/background-checks",
  "/background-checks/all",
  "/background-checks/authorizations",
  "/background-checks/completed",
  "/background-checks/host-families",
  "/background-checks/in-progress",
  "/background-checks/needs-action",
  "/background-checks/needs-review",
  "/cases",
  "/cases/[case-id]",
  "/cases/tags",
  "/chat",
  "/data-verification",
  "/dev",
  "/districts",
  "/documents",
  "/documents/[document-id]",
  "/documents/templates",
  "/documents/templates/[template-id]",
  "/events",
  "/finance",
  "/finance/expenses",
  "/finance/expenses/[finance-section]",
  "/finance/expenses/[finance-section]/[price-id]",
  "/finance/expenses/credits/new",
  "/finance/expenses/expenses/new",
  "/finance/expenses/payments/new",
  "/finance/expenses/repayments/new",
  "/finance/invoices",
  "/finance/invoices/[finance-section]",
  "/finance/invoices/[finance-section]/[price-id]",
  "/finance/invoices/[invoice-id]",
  "/finance/invoices/credits/new",
  "/finance/invoices/new",
  "/finance/invoices/payments/new",
  "/finance/invoices/refunds/new",
  "/home",
  "/home/admissions",
  "/home/agency-operations",
  "/home/agency-recruitment",
  "/home/compliance",
  "/home/host-families",
  "/home/placements",
  "/home/project-help",
  "/home/student-services",
  "/home/supervisions",
  "/home/team-members",
  "/host-families",
  "/host-families/[host-family-profile-id]",
  "/host-families/[host-family-profile-id]/background-checks",
  "/host-families/[host-family-profile-id]/documents",
  "/host-families/[host-family-profile-id]/folder",
  "/host-families/[host-family-profile-id]/members",
  "/host-families/[host-family-profile-id]/notes",
  "/host-families/[host-family-profile-id]/references",
  "/host-families/[host-family-profile-id]/schools",
  "/host-families/[host-family-profile-id]/screening",
  "/host-families/[host-family-profile-id]/students",
  "/host-families/active",
  "/host-families/applicants",
  "/host-families/leads",
  "/host-families/new",
  "/host-families/references",
  "/inbox",
  "/insurance",
  "/insurance/agency-choice",
  "/insurance/assignments",
  "/insurance/batches",
  "/insurance/batches/[batch-id]",
  "/insurance/batches/new",
  "/insurance/enrollments",
  "/insurance/exceptions",
  "/insurance/participants",
  "/insurance/plans",
  "/insurance/plans/[plan-id]",
  "/insurance/settings",
  "/leads",
  "/leads/[lead-id]",
  "/marketing/flyers",
  "/marketing/graphics",
  "/marketing/social-graphics-gallery",
  "/members",
  "/members/[agency-membership-id]",
  "/my-applications",
  "/my-compliance",
  "/my-folder",
  "/organization-memberships/[organization-membership-id]",
  "/organization/background-checks",
  "/organization/employee-configuration",
  "/organization/forms",
  "/organization/forms/[form-id]",
  "/organization/forms/[form-id]/reviews",
  "/organization/goals",
  "/organization/goals/[season-id]",
  "/organization/incentives",
  "/organization/incentives/[incentive-id]",
  "/organization/placement-groups",
  "/organization/program-templates",
  "/organization/program-templates/[program-template-id]",
  "/organization/programs",
  "/organization/programs/[program-id]",
  "/organization/programs/types",
  "/organization/programs/types/[organization-program-type-id]",
  "/organization/quizzes",
  "/organization/quizzes/[quiz-id]",
  "/organization/quizzes/results",
  "/organization/regions-states",
  "/organization/roles",
  "/organization/settings",
  "/organization/statuses",
  "/organization/visibilities",
  "/organization/waitlists",
  "/organization/widgets",
  "/profile",
  "/progress-reports",
  "/project-help",
  "/project-help/[projectId]",
  "/project-help/categories",
  "/project-help/participants",
  "/project-help/tshirt-orders",
  "/quiz-instance/[quiz-instance-id]",
  "/quizzes",
  "/quizzes/[quiz-id]",
  "/quizzes/results",
  "/reports",
  "/reports/hf-monthly-payments",
  "/reports/payment-immigration-report",
  "/reports/placement-report",
  "/reports/placement-report-detailed",
  "/reports/placements-by-team-member",
  "/reports/placements-by-unique-hfs",
  "/reports/relocations-report",
  "/reports/student-numbers-allocations",
  "/reports/tm-recruitment",
  "/resources",
  "/resources/agency",
  "/resources/documents",
  "/resources/training",
  "/resources/training-event-request",
  "/schools",
  "/schools/[school-id]",
  "/schools/[school-id]/admissions-fees",
  "/schools/[school-id]/dates",
  "/schools/[school-id]/folder",
  "/schools/[school-id]/officials",
  "/schools/[school-id]/related-schools",
  "/schools/[school-id]/students",
  "/schools/new",
  "/second-visits",
  "/sentry-example-page",
  "/settings",
  "/sevis/agency-choice",
  "/sevis/aros",
  "/sevis/batches",
  "/sevis/batches/[batch-id]",
  "/sevis/deadlines",
  "/sevis/ds-verification",
  "/sevis/exceptions",
  "/sevis/paid-fees-uploads",
  "/sevis/participants",
  "/sevis/queued-events",
  "/sevis/receipts-uploads",
  "/sevis/settings",
  "/sevis/signature-batches",
  "/sevis/signature-batches/[signature-batch-id]",
  "/sign-in",
  "/sign-in/[...sign-in]",
  "/students",
  "/students/[student-profile-id]",
  "/students/[student-profile-id]/applications",
  "/students/[student-profile-id]/cases",
  "/students/[student-profile-id]/documents",
  "/students/[student-profile-id]/documents/[document-id]",
  "/students/[student-profile-id]/feedback",
  "/students/[student-profile-id]/folder",
  "/students/[student-profile-id]/insurance",
  "/students/[student-profile-id]/notes",
  "/students/[student-profile-id]/progress-reports",
  "/students/[student-profile-id]/second-visits",
  "/students/[student-profile-id]/travel",
  "/students/[student-profile-id]/visa",
  "/students/new",
  "/switch",
  "/team-members",
  "/team-members/[employee-profile-id]",
  "/team-members/[employee-profile-id]/background-checks",
  "/team-members/[employee-profile-id]/documents",
  "/team-members/[employee-profile-id]/folder",
  "/team-members/[employee-profile-id]/host-families",
  "/team-members/[employee-profile-id]/references",
  "/team-members/[employee-profile-id]/schools",
  "/team-members/[employee-profile-id]/screening",
  "/team-members/[employee-profile-id]/students",
  "/team-members/[employee-profile-id]/trainings",
  "/team-members/applicants",
  "/team-members/leads",
  "/team-members/new",
  "/teams",
  "/teams/[team-id]",
  "/teams/[team-id]/host-families",
  "/teams/[team-id]/members",
  "/teams/[team-id]/students",
  "/teams/[team-id]/sub-teams",
  "/travel",
  "/visa-interviews",
] as const;
